export default __webpack_public_path__ + "static/media/text_finish_10.3a0b9799.png";